import { SegmentedControl } from 'ui/segmentedControl';
import { useTranslation } from 'modules/queryBuilder/hooks/useTranslation';
import { InputProps } from 'modules/queryBuilder/contexts';

export enum EDIT_READ_VALUES {
  EDIT = 'edit',
  READ = 'read',
}

export const EditReadSelect = ({
  value,
  onChange,
  ...props
}: Omit<InputProps<boolean>, 'placeholder'>) => {
  const { t } = useTranslation();
  const handleSelectValue = (newValue: EDIT_READ_VALUES) =>
    onChange(newValue === EDIT_READ_VALUES.READ);

  const options = [
    {
      name: t('storybook.buttons.edit'),
      value: EDIT_READ_VALUES.EDIT,
    },
    { name: t('storybook.buttons.read'), value: EDIT_READ_VALUES.READ },
  ];
  return (
    <SegmentedControl
      {...props}
      options={options}
      value={value ? EDIT_READ_VALUES.READ : EDIT_READ_VALUES.EDIT}
      onSelect={handleSelectValue}
    />
  );
};
